export const DEALERSHIP_SALE_TYPES = {
	seller: 'seller',
	buyer: 'buyer',
};

export const DEALERSHIP_STATUS = {
	lead: 'lead',
	deniedInvite: 'denied_invite',
	active: 'active',
	delinquent: 'delinquent',
	junkLead: 'junk_lead',
	needsAttention: 'needs_attention',
	imported: 'imported',
	archived: 'archived',
};

export const DEALERSHIP_BUSINESS_TYPES = {
	franchise: 'franchise',
	independent: 'independent',
	wholesale: 'wholesale',
};

export const isDealershipActive = (status) =>
	status === DEALERSHIP_STATUS.active ||
	status === DEALERSHIP_STATUS.needsAttention ||
	status === DEALERSHIP_STATUS.delinquent;
